<template>
  <div class="">
    <div class="m-2">
      <h1 class="text-center font-bold text-4xl my-4">Generator code finder</h1>
    </div>
    <div class="flex flex-col justify-center items-center text-center">
      <div class="flex w-1/2 flex-row">
        <input class="w-full" type="text" v-model="presetAttributes" />
        <button
          @click="generateFromString"
          class="bg-red-500 border-4 border-yellow-500 px-4 py-2"
        >
          Load
        </button>
        <button
          @click="randomize"
          class="mx-2 bg-red-500 border-4 border-yellow-500 px-4 py-2"
        >
          Randomize
        </button>
      </div>
      <div>
        <br />
        {{ selectedAttributes }}
      </div>
      <img class="w-38" :src="getImageURL" />
    </div>
    <div class="m-2 w-full">
      <div v-if="loading">Loading...</div>
      <div v-else>
        <div class="grid grid-cols-6">
          <div v-for="attribute in attributes" :key="attribute.id">
            {{ attribute.name }}
            <select
              v-model="selectedAttributes[attribute.id]"
            >
            <option :value="opt.id" v-for="opt in getAttributeValues(attribute.id)" :key="opt.id">
              {{ opt.info }}
            </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiurl } from '@/walletHelpers.js'
export default {
  data: function () {
    return {
      attributeValues: [],
      loading: true,
      selectedAttributes: {},
      attributes: [],
      imageurl: null,
      presetAttributes: null
    }
  },
  mounted () {
    this.loadAttributes()
    this.loadAttributeValues()
  },
  methods: {
    getAttributeValues: function (attrid) {
      if (this.attributeValues.length === 0) {
        return []
      }
      return this.attributeValues.filter((item) => item.attribute_id === attrid)
    },
    loadAttributes: function () {
      fetch(apiurl + '/get_attributes')
        .then((r) => r.json())
        .then((data) => {
          this.loading = false
          this.attributes = data
        })
    },
    randomize: function () {
      // Get random value from each attribute
      this.selectedAttributes = this.attributes.reduce((acc, attr) => {
        const avalues = this.getAttributeValues(attr.id)
        const count = avalues.length
        const rand = Math.floor(Math.random() * count)
        acc[attr.id] = avalues[rand].id
        return acc
      }, {})
    },
    generateFromString: function () {
      this.selectedAttributes = JSON.parse(this.presetAttributes)
    },
    loadAttributeValues: function () {
      fetch(apiurl + '/get_attributevalues')
        .then((r) => r.json())
        .then((data) => (this.attributeValues = data))
    }
  },
  computed: {
    getImageURL: function () {
      const attributeString = Object.keys(this.selectedAttributes)
        .map((item) => this.selectedAttributes[item])
        .join(',')
      return '/wheelz/generateFromAttributes/?force=true&attrs=' + attributeString
    }
  },
  components: {
  }
}
</script>


// WEBPACK FOOTER //
// src/components/GeneratorPage.vue